<template>
    <b-tooltip
        :placement="placement"
        :target="target"
    >
        <slot />
    </b-tooltip>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'

export default {
    components: {
        BTooltip
    },
    props: {
        placement: { type: String },
        target: { type: String }
    }
}
</script>